<!-- バックヤード > 配送希望・時間追加 -->
<template>
  <div>
    <v-breadcrumbs
        class="px-0 py-2"
        :items="breadcrumbs"
    />
    <delivery-desired-time-form
        v-if="deliveryDesiredTime"
        :delivery-desired-time="deliveryDesiredTime"
        :is-edit="true"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DeliveryDesiredTimeForm from './_Form'

export default {
  name: 'ByDeliveryDesiredTimeNew',
  components: {
    DeliveryDesiredTimeForm,
  },
  data () {
    return {
      deliveryDesiredTime: null,
      deliveryDesiredTimeId: null,
      // パンくず
      breadcrumbs: [
        { text: '配送希望時間一覧', disabled: false, to: '/backyard/delivery_desired_times', exact: true },
        { text: '配送希望時間編集', disabled: true, to: '' },
      ],
    }
  },

  created () {
    this.deliveryDesiredTimeId = this.$route.params.id
    this.showDeliveryDesiredTime({id: this.deliveryDesiredTimeId}).then((content) => {
      this.deliveryDesiredTime = content
    })
  },
  methods: {
    ...mapActions('backDeliveryDesiredTime', {
      showDeliveryDesiredTime: 'show'
    }),
  },
}
</script>

<style scoped lang="scss">
</style>
